/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import { Grid, Typography, withStyles, Fade, Button } from '@material-ui/core';

import IconButton from '@material-ui/core/IconButton';
import ThumbUp from '@material-ui/icons/ThumbUp';
import ThumbDown from '@material-ui/icons/ThumbDown';

import ReactGA from 'react-ga';
import SectionHeader from '../../components/SectionHeader';
import Asset from '../../components/Asset';

const styles = theme => ({
  feedback: {
    backgroundColor: theme.palette.common.white
    // backgroundImage: 'url(images/bg1.png)'
  },
  img: {
    paddingRight: '100px'
  }
});

const Feedback = class extends React.Component {
  state = {
    voted: false,
    liked: undefined
  };

  sendFeedback = like => {
    const likeds = like === 'yes';
    this.setState({ voted: true, liked: likeds });
    ReactGA.ga('send', 'event', 'feedback', 'like', like);
  };

  render() {
    const { classes } = this.props;
    const { voted, liked } = this.state;
    const showFeedback = voted ? 'flex' : 'none';
    return (
      <section className={classes.feedback}>
        <div className="wrapper">
          <Grid
            container
            direction="column"
            justify="center"
            style={{ minHeight: '60vh' }}
          >
            <Grid item>
              <SectionHeader
                color="primary"
                text="feedback"
                subtitle="aka “Rate our card game”"
                subcolor="secondary"
                img={67}
                imgHeight={43}
              />
            </Grid>
            <Grid item>
              <Grid container spacing={24} alignItems="center">
                <Grid item xs={12} md={4}>
                  <div style={{ textAlign: 'center' }}>
                    <Fade in timeout={1000}>
                      <img
                        src="/images/assets/asset-63.png"
                        alt="Feedback section"
                      />
                    </Fade>
                  </div>
                </Grid>
                <Grid item sm xs={12}>
                  <Typography paragraph variant="body1">
                    Yes, we did it. We are very proud of ourselves (obviously).
                    We spent countless hours playtesting the game to the point
                    where we couldn’t bear to look at it. Or at each other for
                    that matter since all the employee cards are based on real
                    u2i people. <Asset img={6} /> So now we need your help. Yes
                    - <strong>YOU</strong>. If you played our game, please
                    consider leaving us feedback below.
                  </Typography>
                  <Typography
                    align="center"
                    variant="h2"
                    color="primary"
                    gutterBottom
                  >
                    Did you like the game?
                  </Typography>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center'
                    }}
                  >
                    <IconButton
                      aria-label="Yes"
                      color="primary"
                      onClick={() => this.sendFeedback('yes')}
                      disabled={voted}
                      style={voted && liked ? { color: '#3d3d3d' } : {}}
                    >
                      <ThumbUp fontSize="large" />
                    </IconButton>

                    <IconButton
                      aria-label="Yes"
                      color="secondary"
                      onClick={() => this.sendFeedback('No')}
                      disabled={voted}
                      style={voted && !liked ? { color: '#3d3d3d' } : {}}
                    >
                      <ThumbDown fontSize="large" />
                    </IconButton>
                  </div>
                  <div
                    className={classes.voted}
                    style={{ display: showFeedback, flexDirection: 'column' }}
                  >
                    <Typography align="center" paragraph variant="body1">
                      <strong>Thanks!</strong> We appreaciate your feedback!{' '}
                      <Asset img={3} />
                    </Typography>
                    <Typography align="center" paragraph variant="body1">
                      If you want to tell us more please use the button below{' '}
                      <Asset img={10} />
                    </Typography>
                    <Button
                      align="center"
                      target="_blank"
                      onClick={() =>
                        ReactGA.ga(
                          'send',
                          'event',
                          'feedback',
                          'more',
                          'redirect to form'
                        )
                      }
                      style={{ margin: '0 auto 20px', display: 'block' }}
                      href="https://docs.google.com/forms/d/e/1FAIpQLSeQmp4n_rGfXAqcnf5PrFbfv1Tv6RpMG0IjXcqqSq1lrMK8nQ/viewform"
                      variant="contained"
                      color="secondary"
                    >
                      Tell us more!
                    </Button>
                  </div>
                  <Typography paragraph variant="body1">
                    We desperately need it before we can do a full-blown
                    commercial release. And we do want to do a full-blown
                    commercial release. The IT world has been in the shadows (or
                    basement darkness <Asset img={13} />) for too long. It’s
                    time for it to see the light of day. <Asset img={33} />
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </section>
    );
  }
};

export default withStyles(styles)(Feedback);
